import { clsx } from 'clsx'

export const OuterTagStyledDiv = ({ children }) => (
  <div className="relative group hover:bg-(--sp-sidenav-item-hover-bg,var(--sp-color-surface-hover))">
    {children}
    <div data-testid="inactive-tag-hover-div" className="sp-sidenav-api-hover absolute inset-0 opacity-0 bg-(--sp-sidenav-item-hover-bg,var(--sp-color-surface-hover)) group-hover:opacity-100" />
  </div>
)

export const InnerTagStyledDiv = ({ children, active, level }) => (
  <div data-testid="inner-tag-styled-div"
    className={clsx(
      'sp-sidenav-api-tag font-semibold relative z-10',
      level === 0 ? 'ml-7 mr-[18px]' : 'ml-5 mr-1.5',
      active ? 'hover:bg-(--sp-sidenav-item-hover-bg,var(--sp-color-surface-hover)) rounded' : '!mr-0',
    )}>
    {children}
  </div>
)

export const NavItemStyledDiv = ({ lastItem, index, active, level, children, operationsLength, isSelected }) => (
  <div className={level === 0 ? 'ml-[38px] mr-[18px]' : 'ml-[30px] mr-1.5'}>
    <div
      className={clsx('relative border-l border-l-(--sp-color-border-subtle) last:border-none group z-40', lastItem && 'last-item')}
    >
      <div className={clsx('font-sans absolute text-(--sp-color-text-subtle) z-40 top-[5px] -left-[1px]', active && 'group-hover:invisible', isSelected && 'invisible')}>
        -
      </div>
      <div className="relative z-40">
        {index !== operationsLength - 1 && <div className="left-border" />}
        {children}
      </div>
      {!active && <div
        data-testid="inactive-operation-hover-div"
        className={clsx('sp-sidenav-api-hover absolute z-0 opacity-0 bg-(--sp-sidenav-item-hover-bg,var(--sp-color-surface-hover)) group-hover:opacity-100 top-0 bottom-0',
          level === 0 ? '-left-[38px] -right-[18px]' : '-left-[30px] -right-1.5',
        )}
      />}
    </div>
  </div>
)